import { render, staticRenderFns } from "./ParentChildStoryDetail.vue?vue&type=template&id=908c4aae&"
import script from "./ParentChildStoryDetail.vue?vue&type=script&lang=js&"
export * from "./ParentChildStoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports